import { gates } from '../constants/gates';
const keys = {
  CONVERSATIONAL_ENRICHMENT_BETA: 'conversationalEnrichmentBeta',
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE: 'conversationalEnrichmentEmploymentChange',
  ENRICHMENT_ASSOCIATIONS_LISTS: 'enrichmentAssociationsLists',
  ENRICHMENT_AUTO_LAST_ENGAGEMENT_COMPANIES: 'enrichmentAutoLastEngagementCompanies',
  ENRICHMENT_AUTO_PAUSE: 'enrichmentAutoPause',
  ENRICHMENT_IMPORTS_TOOLS: 'enrichmentImportsTools',
  ENRICHMENT_SMART_PROPERTIES: 'enrichmentSmartProperties'
};
const gateLookup = {
  [keys.CONVERSATIONAL_ENRICHMENT_BETA]: gates.CONVERSATIONAL_ENRICHMENT_BETA,
  [keys.CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE]: gates.CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE,
  [keys.ENRICHMENT_ASSOCIATIONS_LISTS]: gates.ENRICHMENT_ASSOCIATIONS_LISTS,
  [keys.ENRICHMENT_AUTO_LAST_ENGAGEMENT_COMPANIES]: gates.ENRICHMENT_AUTO_LAST_ENGAGEMENT_COMPANIES,
  [keys.ENRICHMENT_AUTO_PAUSE]: gates.ENRICHMENT_AUTO_PAUSE,
  [keys.ENRICHMENT_IMPORTS_TOOLS]: gates.ENRICHMENT_IMPORTS_TOOLS,
  [keys.ENRICHMENT_SMART_PROPERTIES]: gates.ENRICHMENT_SMART_PROPERTIES
};
export function getGates(options) {
  return Object.keys(options).map(option => options[option] ? gateLookup[option] : null).filter(gate => gate !== null);
}
export function getGate(key) {
  return gateLookup[key];
}